import axios from "axios";
import { db } from "..//DB/db.js";

export const downloadProductChanges = async () => {
  const lastSync = localStorage.getItem("lastProductSyncAt");
  let data = await sessionStorage.getItem("userData");
  data = JSON.parse(data);
  let token = data;

  const res = await axios.get(`/sync/changes/products?since=${lastSync}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Include other headers as needed
    },
  });

  await db.products.bulkPut(res.data.products);
  await db.products.bulkDelete(res.data.deleted.products);
  await db.customers.bulkPut(res.data.customers);
  await db.customers.bulkDelete(res.data.deleted.customers);

  localStorage.setItem("lastProductSyncAt", res.data.serverTime);
};
